import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import LoadingScreen from '../../../components/LoadingScreen';

const LessonComponent = React.lazy(() => import('./components/LesssonList'));

const LessonList = () => {
  const { pathname } = useLocation();
  return (
    <div>
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
        <LessonComponent />
      </Suspense>
    </div>
  );
}

export default LessonList;